import { createBrowserRouter } from 'react-router-dom';

/**
 * Components
 */
import Layout from '@/layouts/layout';

/**
 * Constants
 */
import routes from './routes';

export const router = createBrowserRouter([
    {
        children: routes,
        element: <Layout />,
    },
]);
